import styled from 'styled-components';

/** The mobile stage. Positioned so the morph overlay + intro layer anchor to it,
 *  and the same coordinate space is used to measure source/destination rects. */
export const Stage = styled.div`
  position: relative;
  height: 100%;
  min-height: 0;
`;

/** The destination (step 1) chrome, resting beneath during the dismiss morph. */
export const ChromeLayer = styled.div`
  height: 100%;
  min-height: 0;
`;

/** The leaving intro plate, overlaid above the chrome while it cross-dissolves. */
export const IntroLayer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
`;
